import React from 'react';
import { Helmet } from 'react-helmet';
import WelcomeSection from '../components/WelcomeSection';
import VisionMissionSection from '../components/VisionMissionSection';
import ChannelPartnerSection from '../components/ChannelPartnerSection';
import WhyChooseUs from '../components/WhyChooseUs';
import FaqSection from '../components/FaqSection';
import Hero from '../components/Hero';
import banner from '../assets/About-Banner.png'
import { useNavigate } from 'react-router-dom';
import FeaturesSection from './../components/FeaturesSection';

const AboutUs = () => {
  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/service');
  };
  return (
    <>
    <Helmet>
        <link rel="canonical" href="https://driveincarspa.com/about" />
        <title>Trusted Professional Car Detailing Company Services</title>
        <meta name="description" content="Choose a professional car detailing company for complete car cleaning, polishing, paint protection, and long-lasting vehicle shine." />
        <meta name="keywords" content="Professional Car Detailing Company
, Premium Car Detailing Service Provider, Professional Car Spa and Auto Detailing Experts, Car Paint Protection and Detailing Specialists, Trusted Car Care and Detailing Company, Automotive Detailing and Car Protection Services" />
        <meta name="author" content="DriveIn Team" />
      </Helmet>
    <Hero
       title={
  <>
    <span className="highlight">Driving the Future of </span><br />
    Professional Car Detailing Company in India
  </>
}
        bgImage={banner}
        onButtonClick={handleServicesClick}
      />
    <WelcomeSection/>
    <VisionMissionSection/>
   <FeaturesSection/>
    <ChannelPartnerSection/>
    <WhyChooseUs/>
    <FaqSection/>
    </>
  );
}

export default AboutUs;
